<template>
  <div class="menu-qua-page">
    <div class="menu-qua-header">
      <div class="menu-qua-header-inner">
        <div class="menu-qua-back" @click="xqesc">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </div>
        <div class="menu-qua-title">{{ pickda[pickxb].ddxq }}</div>
        <div class="menu-qua-placeholder"></div>
      </div>
    </div>

    <div class="menu-qua-content">
      <div class="menu-qua-card">
        <div class="menu-qua-card-header">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7"/>
            <path d="M14 3h7v7"/>
            <path d="M14 14h7v7"/>
            <path d="M3 14h7v7"/>
          </svg>
          <span>{{ Foodlist[pickxb].on1 }}</span>
        </div>
        <div class="menu-qua-card-body">
          <div class="menu-qua-row" v-if="DeskID != 'Food'">
            <span class="menu-qua-label">{{ Foodlist[pickxb].on1 }}</span>
            <span class="menu-qua-value">{{ Desk.Desk }}</span>
          </div>
          <div class="menu-qua-row">
            <span class="menu-qua-label">{{ pickda[pickxb].ddh }}</span>
            <span class="menu-qua-value">{{ Desk.SheetID }}</span>
          </div>
          <div class="menu-qua-row highlight">
            <span class="menu-qua-label">{{ Foodlist[pickxb].on2 }}</span>
            <span class="menu-qua-value">
              <span class="menu-qua-currency">{{ MoneySymbol }}</span>
              <span class="menu-qua-amount">{{ ReMoney.toLocaleString() }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="menu-qua-card">
        <div class="menu-qua-card-header">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>{{ Foodlist[pickxb].on3 }}</span>
        </div>
        <div class="menu-qua-card-body">
          <div class="menu-qua-row">
            <span class="menu-qua-label">{{ pickda[pickxb].xdsj }}</span>
            <span class="menu-qua-value">{{ list[list.length - 1] ? list[list.length - 1].MoneyOpItemsTime : '' }}</span>
          </div>
          <div class="menu-qua-row">
            <span class="menu-qua-label">{{ Foodlist[pickxb].on4 }}</span>
            <span class="menu-qua-value">{{ Desk.MenQua }}</span>
          </div>
          <div class="menu-qua-row">
            <span class="menu-qua-label">{{ Foodlist[pickxb].on5 }}</span>
            <span class="menu-qua-value">
              <span class="menu-qua-currency">{{ MoneySymbol }}</span>
              <span>{{ (ReMoney / Desk.MenQua).toLocaleString() }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="menu-qua-section">
        <div class="menu-qua-section-header">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
          </svg>
          <span>{{ pickda[pickxb].spxx }}</span>
        </div>

        <div class="menu-qua-goods-list">
          <div class="menu-qua-goods-item" v-if="IsBuffet">
            <div class="menu-qua-goods-info">
              <div class="menu-qua-goods-name">
                <span v-if="WXLangGoodsxb == 0">{{ items.Goods }}</span>
                <span v-else-if="WXLangGoodsxb == 1">{{ items.TwoGoods }}</span>
                <span v-else>{{ items.ThreeGoods }}</span>
              </div>
              <div class="menu-qua-goods-bottom">
                <span class="menu-qua-quantity">
                  <span class="menu-qua-quantity-symbol">×</span>
                  <span>{{ Math.round(Desk.ReMoney / Desk.AaMoney) }}</span>
                </span>
                <span class="menu-qua-goods-price">
                  <span>{{ (Math.round(Desk.ReMoney / Desk.AaMoney) * items.MessyPrice).toLocaleString() }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="menu-qua-goods-item" v-for="(item, index) in list" :key="index">
            <div class="menu-qua-goods-info">
              <div class="menu-qua-goods-name">
                <span v-if="WXLangGoodsxb == 0">{{ item.Goods }}</span>
                <span v-else-if="WXLangGoodsxb == 1">{{ item.TwoGoods }}</span>
                <span v-else>{{ item.ThreeGoods }}</span>
              </div>
              <div class="menu-qua-goods-bottom">
                <span class="menu-qua-quantity">
                  <span class="menu-qua-quantity-symbol">×</span>
                  <span>{{ item.Qua }}</span>
                </span>
                <span class="menu-qua-goods-price">
                  <span>{{ item.SellPrice.toLocaleString() }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu-qua-mask" v-if="canzt">
      <div class="menu-qua-dialog">
        <div class="menu-qua-dialog-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <div class="menu-qua-dialog-text">{{ cancen }}</div>
        <div class="menu-qua-dialog-btn" @click="bpq">{{ Foodlist[pickxb].on6 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Qua',
    data() {
      return {
        pickxb: 0,
        sheet: {},
        pickindex: 0,
        SheetID: 0,
        DeskID: 0,
        ReMoney: 0,
        Desk: { ReMoney: 0, AaMoney: 0 },
        Phone: 0,
        MoneySymbol: "",
        cancen: "",
        canzt: false,
        ShopID: 0,
        WXLangGoodsxb: 0,
        list: [{
          SheetID: 0,
          GoodsID: 1001,
          SellPrice: 0,
          OpItemsTime: "00:00"
        }],
        pickda: [
          { fh: "返回", ddxq: "结账单", xdsj: "下单时间", ddh: "订单号", spxx: '商品信息', bz: '备注' },
          { fh: "返回", ddxq: "結賬單", xdsj: "下單時間", ddh: "訂單號", spxx: '菜品信息', bz: '備註' },
          { fh: "Back", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "إرجاع", ddxq: "تفاصيل الطلب", xdsj: "وقت الطلب", ddh: "رقم الطلب", spxx: 'معلومات المنتج', bz: 'ملاحظة' },
          { fh: "ដកថយ", ddxq: "ព័ត៌មានលម្អិត", xdsj: "ពេលវេលាបញ្ជា", ddh: "លេខ​លំដាប់", spxx: 'ព័ត៌មាន​អំពី​ផលិតផល', bz: 'ចំណាំ' },
          { fh: "Volver", ddxq: "Pedidos", xdsj: "Hora del pedido", ddh: "No. de pedido", spxx: 'Detalles del producto', bz: 'note' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Terug", ddxq: "Bestel statement", xdsj: "Bestel tijd", ddh: "Bestelling nummer", spxx: 'Productstatement', bz: 'Opmerking' },
          { fh: "Retour", ddxq: "Paiement", xdsj: "Heure de la commande", ddh: "Numéro de commande", spxx: "Informations sur le produit", bz: "Remarques" },
          { fh: "return", ddxq: "dettagli dell'ordine", xdsj: "dettagli dell'ordine", ddh: "numero d'ordine", spxx: 'Informazioni sui prodotti', bz: 'Nota' },
          { fh: "戻る", ddxq: "お会計", xdsj: "注文時間", ddh: "伝票番号", spxx: '注文内訳', bz: '備考' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Zurück", ddxq: "Kasse", xdsj: "Bestellzeit", ddh: "Bestellnummer", spxx: 'Produktinformationen', bz: 'Bemerkung' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "wrócić", ddxq: "zamówienia", xdsj: "Czas na złożenie zamówienia", ddh: "Numer zamówienia", spxx: 'Informacje o produkcie', bz: 'uwaga' },
          { fh: "return", ddxq: "statement", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Kembali", ddxq: "Checkout", xdsj: "Waktu pemesanan", ddh: "Nomor pesanan", spxx: 'Informasi produk', bz: 'Keterangan' },
          { fh: "กลับ", ddxq: "ชำระเงิน", xdsj: "เวลาสั่ง", ddh: "หมายเลขคำสั่งซื้อ", spxx: 'ข้อมูลผลิตภัณฑ์', bz: 'หมายเหตุ' },
          { fh: "απόδοση", ddxq: "Αποχώρηση", xdsj: "Ώρα παραγγελίας", ddh: "Αριθμός παραγγελίας", spxx: 'Πληροφορίες προϊόντος', bz: 'Παρατήρηση' },
          { fh: "Nazaj", ddxq: "Podrobnosti o naročilu", xdsj: "Čas naročila", ddh: "Številka naročila", spxx: 'Informacije o izdelku', bz: 'Opomba' },
          { fh: "Back", ddxq: "statement", xdsj: "Order time", ddh: "Order number", spxx: 'Commodity information', bz: 'remark' },
          { fh: "qayıtmaq", ddxq: "Kassa", xdsj: "Sifariş vaxtı", ddh: "Sifariş nömrəsi", spxx: 'Məhsul Məlumatı', bz: 'Qeyd' },
          { fh: "ပြန်လည်", ddxq: "စာရင်းချုပ်", xdsj: "စာရင်းချိန်", ddh: "စာရင်းနံပါတ်", spxx: 'ကုန်ပစ္စည်းသတင်းအချက်အလက်', bz: 'မှတ်ချက်' },
          { fh: "geri dön", ddxq: "hesap", xdsj: "sipariş zamanı", ddh: "sipariş numarası", spxx: 'ürün bilgisi', bz: 'not' },
          { fh: "буцах", ddxq: "Төлбөр тооцоо", xdsj: "Захиалсан цаг", ddh: "Захиалгын дугаар", spxx: "Бүтээгдэхүүний мэдээ", bz: "Тайлбар" },
        ],
        Foodlist: [
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台號", on2: "預計應收", on3: "明細", on4: "人數", on5: "預計人均", on6: "確定", on7: "請下單後查看" },
          { on1: "Desk", on2: "Receivable", on3: "Detailed", on4: "Number of people", on5: "Per capita", on6: "Determine", on7: "Please check after placing the order" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "Número de estación", on2: "Créditos previstos", on3: "Detalles", on4: "Número de personas", on5: "Se espera que per cápita", on6: "Determinar", on7: "Por favor, haga un pedido y vea." },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "T", on2: "prijs", on3: "detail", on4: "Aantal personen", on5: "Per persoon", on6: "goed", on7: "Controleer na het plaatsen van de bestelling" },
          { on1: "Numéro de station", on2: "Créances attendues", on3: "Détails", on4: "Nombre de personnes", on5: "Moyenne attendue par habitant", on6: "Confirmer", on7: "Veuillez vérifier après avoir passé la commande" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "テーブル番号", on2: "合計(税込)", on3: "詳細", on4: "ご利用人数", on5: "割り勘", on6: "確定", on7: "データがありません" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "Station Nr.", on2: "Voraussichtlicher Erl?s", on3: "Aufschlüsselung", on4: "Personenzahl", on5: "Voraussichtlicher Pro-Kopf-Betrag", on6: "Best?tigen", on7: "Bitte nach Bestellung einsehen" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
          { on1: "Nomor stasiun", on2: "Perkiraan piutang", on3: "Rincian", on4: "Jumlah orang", on5: "Perkiraan per kapita", on6: "Konfirmasi", on7: "Silakan periksa setelah penempatan pesanan" },
          { on1: "หมายเลขสถานี", on2: "ประมาณการลูกหนี้", on3: "รายละเอียด", on4: "จำนวนคน", on5: "ประมาณการต่อหัว", on6: "แน่นอน", on7: "กรุณาตรวจสอบหลังจากทำการสั่งซื้อ" },
          { on1: "Αριθμός σταθμού", on2: "Εκτιμώμενες απαιτήσεις", on3: "Καθέκαστα", on4: "Αριθμός ατόμων", on5: "Εκτιμώμενο κατά κεφαλήν", on6: "Σίγουρος", on7: "Ελέγξτε μετά την τοποθέτηση της παραγγελίας" },
          { on1: "postaja št.", on2: "Ocenjene terjatve", on3: "Podrobnosti", on4: "Oseba(-e)", on5: "Predvideno na prebivalca", on6: "OK", on7: "Prosimo, preverite po naročilu." },
          { on1: "Station number", on2: "Estimated receivable", on3: "detail", on4: "Person(s)", on5: "Projected Per Capita", on6: "OK", on7: "Please check after ordering." },
          { on1: "Platforma nömrəsi", on2: "Gözlənilən debitor borcları", on3: "Təfərrüatlar", on4: "İnsanların sayı", on5: "Adambaşına düşən gözlənilən", on6: "Əlbəttə", on7: "Sifariş verdikdən sonra yoxlayın." },
          { on1: "စာရင်းနံပါတ်", on2: "မျှော်မှန်းထားသော တောင်းခံမှု", on3: "အသေးစိတ်", on4: "လူအရေအတွက်", on5: "တစ်ဦးချင်းစီမျှော်မှန်းထားသော တောင်းခံမှု", on6: "အဆင်ပြေသည်", on7: "" },
          { on1: "masa no", on2: "beklenen tahsil", on3: "ayrıntı", on4: "kişi sayısı", on5: "beklenen kişi başına", on6: "onayla", on7: "sipariş verdiğinizde kontrol edebilirsiniz" },
          { on1: "Хоолны ширээ захиал", on2: "Хүлээгдэж буй авлага", on3: "Дэлгэрэнгүй мэдээлэл", on4: "Хүмүүсийн тоо", on5: "Нэг хүнд ногдох тооц", on6: "Тэгэлгүй яахав", on7: "Захиалгаа өгсний дараа шалгана уу." },
        ],
        items: {},
        IsBuffet: 0
      }
    },
    mounted() {
      var that = this
      if (localStorage.getItem(this.$route.query.ShopID + 'pickxb'))
        this.pickxb = localStorage.getItem(this.$route.query.ShopID + 'pickxb');
      if (localStorage.getItem(this.$route.query.ShopID + 'pickindex'))
        this.pickindex = localStorage.getItem(this.$route.query.ShopID + 'pickindex')
      if (localStorage.getItem(this.$route.query.ShopID + 'WXLangGoodsxb'))
        this.WXLangGoodsxb = localStorage.getItem(this.$route.query.ShopID + 'WXLangGoodsxb')
	  console.log(this.WXLangGoodsxb)
      this.ShopID = this.$route.query.ShopID
      this.DeskID = this.$route.query.DeskID
      this.Phone = this.$route.query.Phone
      this.axios.get(this.$lujin + "/api/Default/PushOrderItems?DeskID=" + this.DeskID + "&ShopID=" + this.ShopID)
        .then((res) => {
          if (res.data.State) {
            var OrderNumber = res.data.OrderNumber
            var timexb = 0
            var ordertime = setInterval(() => {
              timexb++;
              if (timexb >= 20) {
                clearInterval(ordertime)
              }
              that.axios.get(that.$lujin + "/api/Default/GetOrderItems?DeskID=" + that.DeskID + "&ShopID=" + that.ShopID + "&OrderNumber=" + OrderNumber)
                .then((bpq) => {
                  if (bpq.data.State) {
                    clearInterval(ordertime)
                    var sz = bpq.data.Data
                    var ReMoney = 0
                    for (var i in sz) {
                      ReMoney += sz[i].Money
                      sz[i].MoneyOpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
                    }
                    that.ReMoney = ReMoney
                    that.list = sz
                  }
                })
            }, 1000)
          }
        })
      this.axios.post(that.$lujin + "/api/Default/Parameter?ShopID=" + this.$route.query.ShopID).then((res) => {
        that.MoneySymbol = res.data.data[0].MoneySymbol
        that.Shop = res.data.data[0].Shop
      })
      this.axios.get(this.$lujin + "/api/Default/cha_zuo?ShopID=" + this.$route.query.ShopID + "&DeskID=" + this.$route.query.DeskID)
        .then((res) => {
          that.Desk = res.data.data[0]
          var Desk = res.data.data[0]
          if (Desk.SheetID == "0" || Desk.SheetID == "") {
            that.cancen = that.Foodlist[that.pickxb].on7
            that.canzt = true
          }
        })
      return
      this.axios.get(this.$lujin + "/api/Default/GetFGoods?DeskID=" + this.$route.query.DeskID + "&ShopID=" + this.$route.query.ShopID).then((res) => {
        if (res.data.State) {
          that.IsBuffet = res.data.IsBuffet
          that.items = JSON.parse(res.data.Items).Table[0]
        }
      })
    },
    methods: {
      bpq: function() {
        this.$router.go(-1);
      },
      imageLoad2(index) {
        const img = document.querySelectorAll('.menu-qua-goods-thumb img')[index]
        if (img) {
          img.src = '../static/images/zwtp.png'
        }
      },
      xqesc: function() {
        this.$router.go(-1);
      },
    },
  }
</script>

<style scoped>
.menu-qua-page {
  min-height: 100vh;
  background: #0d1117;
}

.menu-qua-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(16, 21, 30, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.menu-qua-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
}

.menu-qua-back {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.menu-qua-back:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.menu-qua-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.menu-qua-placeholder {
  width: 36px;
}

.menu-qua-content {
  padding-top: 60px;
}

.menu-qua-card {
  margin: 12px;
  background: rgba(22, 27, 34, 0.8);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
}

.menu-qua-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  color: #f04e05;
  font-size: 14px;
  font-weight: 600;
}

.menu-qua-card-body {
  padding: 12px 16px;
}

.menu-qua-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.menu-qua-row.highlight {
  background: rgba(240, 78, 5, 0.06);
  margin: 4px -16px;
  padding: 12px 16px;
  border-radius: 8px;
}

.menu-qua-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

.menu-qua-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.menu-qua-currency {
  color: #f04e05;
  font-size: 14px;
  font-weight: 700;
}

.menu-qua-amount {
  color: #f04e05;
  font-size: 22px;
  font-weight: 700;
}

.menu-qua-section {
  margin: 12px;
}

.menu-qua-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 600;
}

.menu-qua-section-header svg {
  color: #f04e05;
}

.menu-qua-goods-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-qua-goods-item {
  background: rgba(22, 27, 34, 0.8);
  border-radius: 12px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.menu-qua-goods-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-qua-goods-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.menu-qua-goods-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-qua-quantity {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

.menu-qua-quantity-symbol {
  margin-right: 4px;
}

.menu-qua-goods-price {
  color: #f04e05;
  font-size: 16px;
  font-weight: 700;
}

.menu-qua-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-qua-dialog {
  width: 85%;
  max-width: 480px;
  background: rgba(22, 27, 34, 0.95);
  border-radius: 20px;
  padding: 32px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.menu-qua-dialog-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(240, 78, 5, 0.15);
  border-radius: 50%;
  color: #f04e05;
}

.menu-qua-dialog-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.menu-qua-dialog-btn {
  display: inline-block;
  min-width: 160px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  background: #f04e05;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/MenuQua.vue